import { COPILIT_ACTIVE_ID, SET_COPILOT_DIALOG, SET_DASHBOARD_LOADER,SET_NOTIFICATION_LOADER, UPDATE_COPILOT } from "./api";

export const SET_LOADER = "SET_LOADER";

export const setLoader = ({ state }) => ({
  type: SET_LOADER,
  payload: state
});

export const setDashboardLoader = ({ state }) => ({
  type: SET_DASHBOARD_LOADER,
  payload: state
});

export const setNotificationLoader = ({ state }) => ({
  type: SET_NOTIFICATION_LOADER,
  payload: state
});

// export const setCoPilotDialog = ({ state }) => ({
//   type: SET_COPILOT_DIALOG,
//   payload: state
// });

export const updateCopilot = (payload) => ({
  type: UPDATE_COPILOT,
  payload: payload
});

export const setActiveCopilotId = (payload) => ({
  type: COPILIT_ACTIVE_ID,
  payload: payload
});


